/**
 * Native radios that share a name form one group in the browser: checking one unchecks the others without an event.
 * When a radio hands its click back (the parent did not take the value), the radio that was checked before has
 * already been unchecked natively, while its own state still says it is selected. Every mounted VRadio registers how
 * to restore its native checked state under its name, so the radio that hands a click back can restore the group.
 */
const groups = new Map<string, Set<() => void>>();

export function registerRadioInGroup(name: string, syncChecked: () => void): () => void {
  let group = groups.get(name);
  if (!group) {
    group = new Set();
    groups.set(name, group);
  }
  group.add(syncChecked);

  return () => {
    const current = groups.get(name);
    if (!current) {
      return;
    }
    current.delete(syncChecked);
    if (current.size === 0) {
      groups.delete(name);
    }
  };
}

export function syncRadioGroup(name: string): void {
  groups.get(name)?.forEach(syncChecked => syncChecked());
}
